import React, {Component} from 'react';
import {connect} from 'react-redux';
import RentCycleConstants from '../../constants/RentCycleConstants';

class MarketImage extends Component {
    titleCaseRegion(lowerCasedArray) {
        return lowerCasedArray.map((word) => {
            switch (word) {
                case 'u.s.':
                    return 'U.S.' + word.substr(4);
                case 'se':
                    return 'SE' + word.substr(2);
                default:
                    return word[0].toUpperCase() + word.substr(1)
            }
        }).join(' ')
    }

    formatRegion(marketRegion) {
        if (marketRegion === undefined || marketRegion === '') {
            return;
        }

        let lowercaseMarketRegion = marketRegion.toLowerCase();
        let splitMarketRegion = lowercaseMarketRegion.split(' ');

        return this.titleCaseRegion(splitMarketRegion)
    }

    imageUrl(greaterRegion, region, market) {
        if(greaterRegion != null)
        {
            if (greaterRegion =="Asia Pacific")
            {
                greaterRegion="APAC";
            }
            else if (greaterRegion =="Europe")
            {
                greaterRegion="EMEA";
            }

          //  return (process.env.REACT_APP_RENTCYCLE_MARKET_IMAGE_URL + encodeURIComponent(`/${greaterRegion}-${region}-${market}.jpg`));
          return ('#{rentrackermarketimages}#' + encodeURIComponent(`/${greaterRegion}-${region}-${market}.jpg`));

        }
    }

    defaultImg(ev) {
        ev.target.src = ('#{rentrackermarketimages}#' + '/default.jpg');
    }

    render() {

        const {devicetype, classes, comparisonVisible, marketInfo, marketComparisonInfo} = this.props;

        let marketRegion = this.formatRegion(marketInfo.region);
        let marketComparisonRegion = comparisonVisible ? this.formatRegion(marketComparisonInfo.region) : '';
        let marketImage = this.imageUrl(marketInfo.greaterRegion, marketRegion, marketInfo.market);
        let marketComparisonImage = this.imageUrl(marketComparisonInfo.greaterRegion, marketComparisonRegion, marketComparisonInfo.market);

        let imageSrc = this.props.rightPanel ? marketComparisonImage : marketImage;
        let imageClasses = devicetype === 'mobile' ? classes : (comparisonVisible ? 'container-img-comparison' : 'container-img');


        return <img src={imageSrc} onError={this.defaultImg} alt="Buildings" className={imageClasses}/>
    }

}

const mapStateToProps = (state) => {
    return {
        marketInfo: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0]: {},
        marketComparisonInfo: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1]: {}
    };
};

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketImage);
